<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="5">
				<sf-select-group
					:label="getMessage_('SWCC000002')"
					:inputValue="plantCd"
					:options="plantOptions"
					:onChange="value => onChange('plantCd', value)"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group :label="getMessage_('SWCC000217')" :inputValue="userId" :onChange="value => onChange('userId', value)" />
			</el-col>
			<el-col :span="4">
				<sf-input-group :label="getMessage_('SWCC000218')" :inputValue="userName" :onChange="value => onChange('userName', value)" />
			</el-col>
			<el-col :span="5">
				<sf-select-group
					:label="getMessage_('SWCC000106')"
					:inputValue="useYn"
					:options="useYnOptions"
					:onChange="value => onChange('useYn', value)"
				/>
			</el-col>
			<el-col :span="5">
				<sf-select-group
					:label="getMessage_('QWCC002105')"
					:inputValue="mpassYn"
					:options="useYnOptions"
					:onChange="value => onChange('mpassYn', value)"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="search" v-if="isButton_(scrId, 'CR')">
				{{ getButtonMsg_(scrId, 'CR') }}
			</sf-button>
		</template>
	</sf-search-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserManagement/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			plantCd: '',
			userId: '',
			userName: '',
			useYn: 'Y',
			mpassYn: 'Y',
			pageInit: true,
			screen: {}
		};
	},

	computed: {
		...rootComputed,
		...serviceComputed
	},

	watch: {
		//화면 정보 로딩시
		screen() {
			if (this.pageInit && this.screen.defaultPageSize && this.user.plantCd) {
				//페이지 정보 초기화
				this.setState_({
					key: 'users',
					value: { currentPage: 1, pageUnit: this.screen.defaultPageSize, data: [] }
				})
					.then(() => {
						this.pageInit = false;
						this.plantCd = this.user.plantCd;
						// * 2022-07-21 snjung start
						this.setDeptCdList(); //부서코드 combobox
						this.setEmployeeTypeList(); // 사용자 타입 combobox
						// end					
						this.setPlantList(); //공장 코드 selectBox option을 위한 리스트 조회
						this.setUseYnList(); //사용 유무 공통 코드 selectBox option을 위한 리스트 조회
						this.search(); //사용자 조회
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					});
			}
		},
		langCd() {
			this.setUseYnList();
		}
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},

	methods: {
		...rootMethods,
		...serviceMethods,

		onChange(key, value) {
			this[key] = value;
			if (key === 'useYn') {
				this.search();
			}
		},

		//공장 코드 조회 Action 호출
		async setPlantList() {
			this.$sf_toggleLoading(true);
			await this.getPlantList_()
				.then(header => {
					//api 응답이 비정상일 경우만 알림 처리
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//사용 유무 공통 코드 조회 Action 호출
		async setUseYnList() {
			this.$sf_toggleLoading(true);
			await this.getUseYnList_()
				.then(header => {
					//api 응답이 비정상일 경우만 알림 처리
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		//부서코드 공통 코드 조회 Action 호출 * 2022-07-21 snjung
		async setDeptCdList() {			
			this.$sf_toggleLoading(true);
			await this.getDeptCdList_()
				.then(header => {
					//api 응답이 비정상일 경우만 알림 처리
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//사용자 타입 공통 코드 조회 Action 호출 * 2022-07-21 snjung
		async setEmployeeTypeList() {
			this.$sf_toggleLoading(true);
			await this.getEmployeeTypeList_()
				.then(header => {
					//api 응답이 비정상일 경우만 알림 처리
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//사용자 조회 Action 호출
		async search() {
			this.$sf_toggleLoading(true);
			await this.select_({
				plantCd: this.plantCd,
				userId: this.userId,
				userName: this.userName,
				useYn: this.useYn,
				mpassYn: this.mpassYn,
				currentPage: 1,
				pageUnit: this.users.pageUnit
			})
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
